import { ROLE_MASCARADE } from "access-roles/roles";
import { ENTITY } from "constants/info-header";

export const enableMascarade = ({ roles, entity, canMascarade }) =>
  !localStorage.getItem("mascarade_token") &&
  entity === ENTITY.STAFF &&
  (roles.includes(ROLE_MASCARADE) || canMascarade);
